function t(t){return void 0===t}export{t as default};
//# sourceMappingURL=isUndefined.js.map
